import React from 'react'
import Photo from '../Photo/Photo'

const PhotoPage = () => {
    return (
        <div><Photo /></div>
    )
}

export default PhotoPage